import I18n from 'I18n';
import CRMPropertyFieldTypes from 'automation-ui-flow-core/fields/CRMPropertyFieldTypes';
import CRMPropertyValueTypes from 'automation-ui-flow-core/fields/CRMPropertyValueTypes';
import PropertyFieldTypes from 'automation-ui-flow-core/fields/PropertyFieldTypes';
import convertTypeDefinitionToOptions from 'automation-ui-action-features/action-outputs/utils/convertTypeDefinitionToOptions';
/**
 * Generate a `fieldType` for a given output `type`
 * This creates a CRM Object-like shape, which can then
 * be used to generate an addon type, etc.
 */
export const getFieldTypeFromOutputType = type => {
  switch (type) {
    case CRMPropertyValueTypes.STRING:
      return CRMPropertyFieldTypes.TEXT;
    case CRMPropertyValueTypes.NUMBER:
      return CRMPropertyFieldTypes.NUMBER;
    case CRMPropertyValueTypes.BOOL:
      return CRMPropertyFieldTypes.BOOLEAN_CHECKBOX;
    case CRMPropertyValueTypes.DATETIME:
      // No field type for datetime
      return CRMPropertyValueTypes.DATETIME;
    case CRMPropertyValueTypes.DATE:
      return CRMPropertyFieldTypes.DATE;
    case CRMPropertyValueTypes.ENUM:
      return CRMPropertyFieldTypes.SELECT;
    // TODO JP 3/5 add support for these types
    case CRMPropertyValueTypes.PHONE_NUMBER:
      return CRMPropertyFieldTypes.PHONE_NUMBER;
    default:
      return CRMPropertyFieldTypes.TEXT;
  }
};

/**
 * Not all action outputs have their options properly defined.
 * For some, we can generate them manually.
 */
export const createOptionsForFieldDefinition = typeDefinition => {
  if (typeDefinition.type === CRMPropertyValueTypes.BOOL && (!typeDefinition.options || !typeDefinition.options.length)) {
    return [{
      displayOrder: 0,
      hidden: false,
      label: I18n.text('automation-ui-action-features.boolean-labels.label-yes'),
      value: 'true'
    }, {
      displayOrder: 0,
      hidden: false,
      label: I18n.text('automation-ui-action-features.boolean-labels.label-no'),
      value: 'false'
    }];
  }
  return typeDefinition.options;
};

/**
 *
 * @param {Array} actionOutputs Array of action outputs
 *
 * @return An array of action outputs as "addon". This type of
 *         array is primarily used with UISelect components
 */
export const getActionOutputsAsAddon = actionOutputs => {
  if (!actionOutputs || !actionOutputs.length) {
    return {};
  }
  const outputsByActionIdAsAddon = {};
  actionOutputs.forEach(({
    outputFieldDefinitions,
    actionId: sourceActionId
  }) => {
    const fields = outputFieldDefinitions.map(fieldDefinition => convertTypeDefinitionToOptions(Object.assign({}, fieldDefinition.typeDefinition, {
      label: fieldDefinition.typeDefinition.name,
      options: createOptionsForFieldDefinition(fieldDefinition.typeDefinition),
      name: fieldDefinition.typeDefinition.name,
      fieldType: getFieldTypeFromOutputType(fieldDefinition.typeDefinition.type)
    }))).map(property => property.fieldType === PropertyFieldTypes.CHECKBOX ? Object.assign({}, property, {
      fieldType: PropertyFieldTypes.ENUM
    }) : property);
    outputsByActionIdAsAddon[sourceActionId] = {
      fields
    };
  });
  return outputsByActionIdAsAddon;
};